if (!customElements.get('product-form')) {
    class GhProduct extends HTMLElement {
        constructor() {
            super();
            this.thumbsSlider = null;
            this.fullSlider = null;
            this.thumbsParent = this.querySelector('.gh-product__image-thumbnails');
            this.fullImagesParent = this.querySelector('.gh-product__image-slider');
            this.variants = this.querySelectorAll('.gh-product__variant');
            this.tabs = this.querySelectorAll('.gh-product__tab-title');
            this.tabsContents = this.querySelectorAll('.gh-product__tab-content');
            this.addToCartButton = this.querySelector('.gh-product__button .gh-button');
            this.quantitySelector = this.querySelector('.gh-product__quantity-selector');
            this.quantitySelector.querySelectorAll('.gh-product__selector-button').forEach(button => {
                button.addEventListener('click', this.updateQuantity.bind(this,button));
            });
            this.variants.forEach(variant => {
                variant.addEventListener('click', () => {
                    this.variants.forEach(v => v.classList.remove('active'));
                    variant.classList.add('active');
                });
            });
            this.tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    this.tabs.forEach(t => t.classList.remove('active'));
                    tab.classList.add('active');
                    const index = tab.dataset.index;
                    this.tabsContents.forEach(content => {
                        content.classList.remove('active');
                    });
                    console.log(index);
                    this.tabsContents[tab.dataset.index].classList.add('active');
                });
            });
            this.addToCartButton.addEventListener('click', this.addToCart.bind(this));
            this.updateSliders();
            window.addEventListener('resize', () => {
                this.updateSliders();
            });
            
            // Scroll to FAQ section if URL has ?show=faq parameter
            this.checkAndScrollToFAQ();
        }
        
        checkAndScrollToFAQ() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('show') === 'faq') {
                // Use setTimeout to ensure DOM is fully rendered
                setTimeout(() => {
                    const faqSection = document.querySelector('.gh-faqs');
                    if (faqSection) {
                        faqSection.scrollIntoView({ 
                            behavior: 'smooth', 
                            block: 'start' 
                        });
                    }
                }, 100);
            }
        }
        updateQuantity(button) {
            const action = button.dataset.action;
            console.log("updateQuantity", action);
            let value = parseInt(this.quantitySelector.querySelector('.gh-product__selector-input').dataset.value);
            if(action === 'plus'){
                value++;
            }else if(value > 1){
                value--;
            }
            this.quantitySelector.querySelector('.gh-product__selector-input').dataset.value = value;
            this.quantitySelector.querySelector('.gh-product__selector-input').textContent = value;
        }
        addToCart() {
            const id = this.querySelector('.gh-product__variant.active').dataset.variantId;
            const quantity = this.querySelector('.gh-product__selector-input').dataset.value;
            console.log(id, quantity);
            this.addToCartButton.classList.add('loading');
            this.addToCartButton.querySelector('.loading__spinner').classList.remove('hidden');
            // Get cart drawer reference
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            // Prepare form data with sections to update
            const formData = new FormData();
            formData.append('id', id);
            formData.append('quantity', quantity);
            if (cart) {
                formData.append(
                    'sections',
                    cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append('sections_url', window.location.pathname);
            }
            
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            }).then(response => response.json()).then(response => {
                console.log(response);
                
                // Check for errors
                if (response.status) {
                    console.error('Error adding to cart:', response.description);
                    return;
                }
                
                // Trigger cart drawer to open and update contents
                if (cart) {
                    cart.renderContents(response);
                }
                
                // Publish cart update event (if using pub/sub system)
                if (typeof publish !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'gh-product',
                        productVariantId: product.id,
                        cartData: response,
                    });
                }
                
            }).catch(error => {
                console.error(error);
            }).finally(() => {
                console.log('finally');
                this.addToCartButton.classList.remove('loading');
                this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
            });
        }
        initSliders() {
            // if(this.thumbsSlider){
            //    this.thumbsSlider.update();
            // }else{
            //     this.thumbsSlider = new Swiper(this.thumbsParent, {
            //         direction: 'vertical',
            //         effect: 'slide',
            //         slidesPerView: 7,
            //         spaceBetween: 12,
            //         loop: true
            //     });
            // }
            if(!this.fullSlider){
                this.fullSlider = new Swiper(this.fullImagesParent, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    loop: true,
                });
            }
            this.thumbsParent.querySelectorAll('.gh-product__image-thumb').forEach(thumb => {
                thumb.addEventListener('click', () => {
                    const index = thumb.dataset.index;
                    console.log(index);
                    this.fullSlider.slideTo(index);
                });
            });
        }
        updateSliders() {
            const fullSliderWidth = this.fullImagesParent.offsetWidth;
            const fullSliderHeight = this.fullImagesParent.offsetHeight;
            console.log(fullSliderWidth, fullSliderHeight);
            this.thumbsParent.style.maxHeight = `${fullSliderHeight}px`;
            this.thumbsParent.style.height = `auto`;
            this.initSliders();
        }
    }
    customElements.define('gh-product', GhProduct);
}


